/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: ryanxu ryanxu@chaocanshu.ai
 * @LastEditTime: 2026-03-31 21:11:18
 * @FilePath: /knit-web/src/locale/zh-CN/workflow.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  workflow: {
    ai: {
      askMode: '问答模式',
      agentMode: '代理模式',
      newChat: '新会话',
      history: '历史记录',
      collapse: '收起',
      welcomeTitle: '👋 你好, 我可以帮你做什么？',
      suggestion: {
        oneLine: '带记忆与人设的多 NPC 系统',
        upload: '自动化简历筛选流水线',
        testInput: 'Webhook 触发的动态网页',
        comment: '从发票文件中提取并处理信息',
        document: '生成工作流文档',
      },
      inputPlaceholder: '请输入..., @提及节点',
      upload: '上传',
      send: '发送',
      currentSession: '当前会话',
      noHistory: '暂无历史会话',
      clearSession: '清空会话',
      clearSessionConfirm: '确定要清空当前会话吗？',
      versionHistory: '版本历史',
      executionPlan: '执行计划',
      workflowPreview: '工作流预览',
      keep: '保持',
      added: '新增',
      modified: '修改',
      removed: '删除',
      confirmExecution: '确认执行',
      clarifyNotice: '需要确认以下信息',
      required: '必填',
      optional: '选填',
      selectNodesPrompt: '请选择要优化的节点：',
      processing: '正在处理中...',
      thinking: '思考中...',
      thoughtComplete: '已思考',
      hideDiff: '隐藏差异',
      showDiff: '显示差异',
      applyToCanvas: '应用到画布',
      appliedToCanvas: '已应用到画布',
      undoApply: '撤销应用',
      generatedWorkflows: '已生成 {count} 个工作流',
      workflowIndex: '工作流 {index}',
      createWorkflow: '创建新工作流',
      reminderLabel: '提醒',
      reDescribe: '重新描述',
      addedImages: '已添加 {count} 张截图',
      screenshotName: '截图{index}',
      noVersionHistory: '暂无版本历史',
      restoreVersion: '恢复',
      clickNodeToViewConfig: '点击节点查看配置',
      noConfig: '暂无配置',
      wsDisconnected: 'WebSocket 未连接',
      wsDisconnectedRetry: 'WebSocket 未连接，请稍后重试',
      voiceInputInProgress: '语音输入功能开发中',
      selectNodesHint: '请在画布上选择节点，然后返回输入问题',
      selectedNodesCount: '已选择 {count} 个节点',
      sessionCleared: '会话已清空',
      workflowGenerated: '工作流已生成',
      testMessageFailed: '测试消息发送失败',
      planExecutionStarted: '开始执行计划',
      confirmPlanFailed: '确认计划失败',
      planRejectedResponse: '好的，已取消执行计划。请告诉我您想怎么调整？',
      rejectPlanFailed: '取消计划失败',
      confirmActionMessage: '确认',
      solutionRejectedResponse: '好的，已取消。请告诉我您想怎么调整？',
      submitFailed: '提交失败',
      selectAtLeastOneNode: '请至少选择一个节点',
      optimizeNodeProgress: '优化节点: {name} ({current}/{total})',
      optimizeNodeFailed: '优化节点 {name} 失败，请重试',
      optimizeNodesSuccess: '已完成 {count} 个节点的优化',
      applyWorkflowSuccess: '已应用：新增 {added} 个节点（可撤销）',
      applyWorkflowSuccessWithModified:
        '已应用：新增 {added} 个节点，修改 {modified} 个节点（可撤销）',
      undoApplySuccess: '已撤销工作流应用',
      applyPendingWorkflowSuccess:
        '工作流 {index} 已应用：新增 {added} 个节点（可撤销）',
      applyPendingWorkflowSuccessWithModified:
        '工作流 {index} 已应用：新增 {added} 个节点，修改 {modified} 个节点（可撤销）',
      creatingWorkflow: '正在创建工作流 {index}...',
      fileLoaded: '已加载文件: {name}',
      fileReadFailed: '文件读取失败',
      handleFailed: '处理失败',
      handleFailedWithMessage: '抱歉，处理您的请求时出现了错误：{message}',
      operationCancelled: '操作已取消',
      undoSuccess: '已撤销',
      sessionCreated: '已创建新会话',
      sessionDeleted: '会话已删除',
      sessionRenamed: '会话已重命名',
      sessionSearch: '搜索会话...',
      sessionToday: '今天',
      sessionOlder: '更早',
      sessionEmpty: '暂无会话',
      sessionRename: '重命名',
      sessionDeleteBtn: '删除',
      sessionDeleteConfirmTitle: '删除会话',
      sessionDeleteConfirmContent: '确定要删除该会话吗？删除后无法恢复。',
      sessionRunningAlert: '{count} 条回复生成中',
      sessionUnreadAlert: '{count} 条未读回复',
      sessionViewDetails: '查看详情',
      imageTypeInvalid: '请上传 PNG、JPG、GIF 或 WebP 格式的图片',
      imageSizeLimit: '图片大小不能超过 5MB',
      imageAdded: '已添加截图: {name}',
      imageReadFailed: '图片读取失败',
      executeResourceSuggestionPlaceholder:
        '即将执行 {count} 项资源建议（功能开发中）',
      placeholder: {
        executing: '执行中，请等待...',
        clarify: '请回答上面的问题，或直接输入补充信息',
        selectNodes: '请在上方选择要优化的节点，或输入其他指令',
        default: '输入消息，按 Enter 发送，Shift+Enter 换行',
      },
      phase: {
        idle: '空闲',
        clarify: '需求确认',
        plan: '规划中',
        confirm: '待确认',
        execute: '执行中',
        selectNodes: '选择节点',
      },
      stage: {
        intentRecognition: '需求分析',
        solutionDesign: '方案规划',
        parameterExtraction: '参数解析',
        workflowGeneration: '流程构建',
        workflowOptimization: '智能优化',
        analyzing: '深度分析',
        processing: '执行处理',
        completing: '最终确认',
        default: '智能处理',
      },
      testTool: {
        label: '测试工具',
        title: 'Copilot 测试工具',
        type: {
          label: '测试类型',
          preset: '预设用例',
          random: '随机生成',
          stress: '压力测试',
        },
        preset: {
          select: '选择测试场景',
          rounds: '共 {count} 轮对话',
        },
        random: {
          title: 'LLM 智能生成测试用例',
          domain: '领域',
          complexity: '复杂度',
          rounds: '对话轮数',
          focus: '测试重点',
          focusOptional: '可选',
          generate: 'LLM 智能生成',
          generating: 'LLM 生成中...',
          domains: {
            minecraft: 'Minecraft',
            npc: 'NPC系统',
            combat: '战斗系统',
            quest: '任务系统',
            economy: '经济系统',
          },
          complexities: {
            simple: '简单',
            medium: '中等',
            complex: '复杂',
          },
          focuses: {
            variable_ref: '变量引用',
            context_memory: '上下文记忆',
            multi_turn: '多轮修改',
            edge_case: '边界情况',
          },
        },
        stress: {
          config: '压力测试配置',
          concurrent: '并发数',
          requests: '请求数',
        },
        cases: {
          title: '测试用例 ({count})',
          run: '运行测试',
          running: '测试中...',
          insert: '插入当前用例',
          viewReport: '查看报告',
        },
        report: {
          title: '测试报告',
          total: '总用例',
          passed: '通过',
          failed: '失败',
          avgResponse: '平均响应',
        },
        message: {
          generated: 'LLM 生成了 {count} 个测试用例',
          parseError: '无法解析 LLM 返回的内容',
          formatError: 'LLM 返回格式错误',
          generateFailed: '生成失败: {error}',
          fallback: 'LLM 不可用，使用简单模板生成',
          emptyResponse: '响应为空',
          requestFailed: '请求失败',
        },
      },
      applyWorkflow: '应用工作流',
      previewWorkflow: '预览工作流',
      multiWorkflowNotice: '找到多个匹配的工作流，请选择一个进行预览：',
      reminder: {
        title: 'AI 助手提示',
        v0: '我是您的 AI 助手，帮助您构建和优化工作流。',
        v1: '提示：您可以用自然语言描述您想要的工作流，我会为您生成。',
        v2: '提示：您可以让我解释任何节点或整个工作流的逻辑。',
        v3: '提示：试试"生成测试输入"来帮助您调试工作流。',
      },
    },
    publishModal: {
      title: '发布工作流',
      okPublish: '发布版本',
      okPublishing: '发布中...',
      versionLabel: '版本号',
      versionPlaceholder: '请输入，版本号格式参考v1.0.0',
      latestVersion: '当前最新版本：',
      descriptionLabel: '版本描述',
      descriptionPlaceholder: '请输入',
      rules: {
        versionRequired: '请输入版本号',
        versionFormat: '版本号格式参考v1.0.0',
      },
    },
    index: {
      title: '我的工作流',
      createWorkflow: '创建工作流',
      importWorkflow: '导入工作流',
      importModal: {
        title: '导入工作流',
        uploadJsonFile: '上传 JSON 文件',
        uploadHint: '请上传符合工作流定义格式的 JSON 文件。',
        messages: {
          importSuccess: '导入成功',
          importFailed: '导入失败',
        },
        errors: {
          invalidJsonObject: '数据格式错误，应为 JSON 对象',
          missingName: '缺少工作流名称 (name)',
          missingNodes: '缺少节点定义 (nodes) 或格式错误',
          missingEdges: '缺少连线定义 (edges) 或格式错误',
          missingEntryNode: '缺少入口节点定义 (entry_node)',
          parseFailed: 'JSON 文件解析失败，请检查格式',
          uploadValidFileFirst: '请先上传并解析有效的工作流 JSON 文件',
        },
      },
      allTags: '全部标签',
      filterByMember: '按成员筛选',
      typeToSearchOrCreate: '输入以搜索或创建',
      searchTags: '搜索标签',
      search: '搜索',
      empty: '未找到工作流',
      noDescription: '暂无描述',
      noTagsFound: '未找到标签',
      updatedAt: '更新于',
      creator: '创建者',
      editor: '最后编辑者',
      addTag: '添加标签',
      manageTags: '管理标签',
      tagColor: '颜色',
      createTag: '创建标签',
      createAndBindTag: '创建并绑定 "{name}"',
      saveTag: '保存标签',
      editTag: '编辑',
      deleteTag: '删除',
      tagDescriptionPlaceholder: '请输入标签描述（可选）',
      tagNameRequired: '请输入标签名称',
      tagNameDuplicate: '标签名称已存在',
      tagCreateSuccess: '标签创建成功',
      tagCreateAndBindSuccess: '标签已创建并绑定',
      tagUpdateSuccess: '标签更新成功',
      tagDeleteSuccess: '标签删除成功',
      bindSuccess: '标签绑定成功',
      unbindSuccess: '标签解绑成功',
      deleteTagTitle: '删除标签“{name}”',
      deleteTagConfirm: '删除后将影响已关联此标签的工作流，确认继续吗？',
      confirm: '确认',
      cancel: '取消',
      edit: '编辑',
      clone: '复制',
      delete: '删除',
    },
    detail: {
      nav: {
        goTo: '前往',
        homepage: '主页',
        myWorkflows: '我的工作流',
        orchestrate: '编排',
        triggers: '触发器',
        logs: '日志',
        test_tasks: '测试任务',
      },
      triggers: {
        title: 'Triggers',
        refresh: '刷新',
        never: 'Never',
        columns: {
          name: 'Trigger Name',
          description: 'Description',
          status: 'Status',
          updatedAt: 'Updated At',
          lastTriggeredAt: 'Last Triggered',
          action: 'Action',
        },
        status: {
          active: 'In Service',
          disabled: 'Disabled',
        },
        messages: {
          loadFailed: '加载 Trigger 列表失败',
          enabled: '已启用 Trigger',
          disabled: '已禁用 Trigger',
          toggleFailed: '切换 Trigger 状态失败',
        },
      },
      testTasks: {
        title: 'Test Tasks',
        refresh: '刷新',
        defaultStartNode: 'Start Node',
        taskNameValue: 'Test Run（{startNodeName}）',
        columns: {
          taskName: 'Task Name',
          startTime: 'Start Time',
          status: 'Status',
          runTime: 'Run Time',
          requestId: 'Request ID',
          executionId: 'Execution ID',
          executor: 'Executor',
          totalTokens: 'Total Tokens',
        },
      },
      edit: '编辑',
      editInfo: '编辑信息',
      saveNotice: '注意保存会保存工作流所有信息，包括节点配置',
      recordLog: '执行记录',
      protocolBound: '已绑定执行标识',
      updatedAt: '更新于',
      catalog: '目录：',
      loading: '加载中...',
    },
    executionExample: {
      title: '执行示例',
      upload: '上传示例',
      exampleName: '示例名称',
      exampleNamePlaceholder: '请输入示例名称',
      exampleCatalog: '示例目录',
      exampleCatalogPlaceholder: '请选择示例目录',
      exampleType: '示例类型',
      exampleTypePlaceholder: '请选择示例类型',
      typeWorkflow: '工作流',
      typeNode: '节点',
      creator: '创建者',
      creatorPlaceholder: '请输入创建者',
      reset: '重置',
      viewConfig: '查看配置',
      deleteConfirm: '确定删除该示例吗？',
      delete: '删除',
      tableColumns: {
        exampleName: '示例名称',
        exampleCatalog: '示例目录',
        exampleType: '示例类型',
        creator: '创建者',
        createdAt: '创建时间',
        actions: '操作',
      },
    },
    scheduler: {
      status: '调度器状态',
      running: '运行中',
      notStarted: '未启动',
      totalTasks: '定时任务数',
      totalSuccess: '成功执行次数',
      totalFailure: '失败执行次数',
      taskList: '定时任务列表',
      refresh: '刷新',
      enabled: '已启用',
      disabled: '已禁用',
      hasError: '有错误',
      disable: '禁用',
      enable: '启用',
      viewWorkflow: '查看工作流',
      loadFailed: '加载定时任务失败',
      taskEnabled: '任务已启用',
      enableFailed: '启用失败',
      enableTaskFailed: '启用任务失败',
      taskDisabled: '任务已禁用',
      disableFailed: '禁用失败',
      disableTaskFailed: '禁用任务失败',
      tableColumns: {
        workflow: '工作流',
        cron: 'Cron 表达式',
        status: '状态',
        successFailure: '成功/失败',
        lastExecutedAt: '最后执行时间',
        lastError: '最后错误',
        actions: '操作',
      },
    },
    history: {
      title: '变更记录',
      totalCount: '共 {count} 条',
      noRecords: '暂无记录',
      tip: '您的编辑操作将被跟踪并保存在当前会话，离开页面后记录会被清除。（只会记录近50次操作）',
      eventTypes: {
        position: '移动',
        add: '新增',
        remove: '删除',
        init: '初始化',
        update: '变更',
      },
      actionPrefix: {
        node: '节点{action}',
        edge: '连线{action}',
      },
      actionWithName: '{action} · {name}',
      actionWithLink: '{action} · {source} → {target}',
      nodesCount: '{count}个节点',
      edgesCount: '{count}条连线',
      batchSummary: '{action} · {details}',
      mixedBatch: '批量操作 · {count}项变更',
      unknown: '未知',
      unknownChange: '未知变更',
      initialState: '初始状态',
      currentState: '当前状态',
      stepsBack: '{count} 步后退',
      stepsForward: '{count} 步前进',
      justNow: '刚刚',
      minutesAgo: '{count} 分钟前',
      hoursAgo: '{count} 小时前',
      daysAgo: '{count} 天前',
      loadToCurrent: '加载到当前',
      clearHistory: '清除记录',
      clearHistoryConfirm: '确定要清除所有变更记录吗？',
    },
    floatingActions: {
      zoomOut: '缩小',
      zoomIn: '放大',
      selectNodes: '选择节点',
      dragCanvas: '拖动画布',
      optimizeLayout: '优化布局',
      fitView: '适应窗口',
      addNode: '添加节点',
      nodes: '节点',
    },
    actions: {
      validateIssues: '发现 {count} 个配置问题',
      issuesCount: '{count} 个问题',
      save: '保存',
      undo: '撤销',
      redo: '重做',
      history: '历史记录',
      testRun: '测试运行',
      testConfig: '测试配置',
      publish: '发布',
      version: '版本',
      export: '导出',
      exportJson: '导出 Json',
      exportSuccess: '导出成功',
      collaborationConnected: '协同服务已连接 (当前在线: {count}人)',
      collaborationDisconnected: '协同服务断开/离线',
      cannotResetWhileOthersOnline: '有其他用户在线时无法重置协同数据',
      connected: '已连接',
      offline: '离线',
      otherOnlineUsers: '其他在线用户',
      onlineUsers: '在线用户',
      singleEntryNodeRequired: '工作流只能有一个入口节点',
      entryNodeRequired: '工作流必须有一个入口节点',
      testRunPopover: {
        title: '选择运行入口',
        inputGroup: '输入',
        triggerGroup: '触发器',
        unpublished: '未发布',
        triggerHint: '未发布的 Trigger 请先发布后再执行。',
        noRunnableEntry:
          '当前没有可执行的入口，请先发布 Trigger 或检查入口节点配置。',
      },
      workflowValidationError: '工作流配置有误，请查看检查清单修正后再保存',
      nodeName: '节点 {id}',
      help: '帮助',
      workflowDocument: '工作流文档',
      autoLayout: '自动布局',
      saveFailed: '保存失败',
      backendError: '后端错误',
      fieldNames: {
        promptVars: '提示词变量',
        inputVars: '输入变量',
        outputVars: '输出变量',
        modelName: '模型名称',
        name: '名称',
        description: '描述',
        itemIndex: '{field} 第{index}项',
      },
      publishPopover: {
        title: '发布',
        latestVersion: '最新版本',
        versionLabel: '版本 *',
        versionPlaceholder: '如 V1.1.0',
        versionDescription: '版本描述',
        versionDescriptionPlaceholder: '输入发布更新描述',
        updateProtocolTargets: '更新协议目标',
        selectProtocol: '选择执行标识',
        selectProtocolPlaceholder: '选择要更新的执行标识',
        protocolTargeted: '已指向',
        protocolNotTargeted: '未指向',
        publishUpdate: '发布更新',
        workflowAsTool: '工作流为工具',
        publishAsTool: '发布为工具',
        toolUpdate: '工具更新',
        publishAsTemplate: '发布为模板',
        triggerActivated: '发布成功，当前工作流中的 Trigger 已生效',
      },
    },
    nodes: {
      common: {
        model: '模型',
        modelName: '模型名称',
        inputVars: '输入变量',
        outputVars: '输出变量',
        noDescription: '无描述',
        notConfigured: '暂未配置',
      },
      aggregator: {
        noGroups: '无聚合变量',
        noInputVars: '无输入变量',
        group: '分组',
      },
      conditional: {
        tip: "Tip: {'{}'}代表是变量",
        noBranches: '暂无分支',
        defaultBranch: '默认分支',
        branch: '分支',
        and: '且',
        or: '或',
      },
      intent: {
        description: '描述',
        promptVars: '提示词变量',
        option: '选项',
      },
      loop: {
        countLoop: '计数循环',
        whileLoop: '条件循环',
        forEachLoop: '集合循环',
        loop: '循环',
        count: '次数',
        loopCountVar: '循环次数变量',
        collection: '集合',
        collectionKey: '集合key',
        condition: '条件',
        dropHint: '拖拽节点到此处作为循环体，按住ctrl键拖拽可移出循环体',
        notSet: '未设置',
        notConfigured: '暂未配置',
      },
      subworkflow: {
        referencedWorkflow: '引用工作流',
        inputMapping: '输入映射',
      },
    },
  },
};
